export const SET_IS_OPEN = "SET_IS_OPEN"


export const setIsOpen = (open, products) => ({
    type: SET_IS_OPEN,
    payload: {
        open,
        products
    }
})
